import React from 'react'
import PropTypes from 'prop-types'
import { ProductPrices } from 'types'
import exact from 'prop-types-exact'
import { pure } from 'recompose'
import { getGiftMembershipCost, formatCurrency } from 'utils'

const propTypes = {
  membershipPrices: ProductPrices.isRequired,
  selectedMembershipType: PropTypes.string.isRequired,
  withDetail: PropTypes.bool,
}

function GiftInvoice({
  membershipPrices,
  selectedMembershipType,
  withDetail = false,
}) {
  const membershipCost = getGiftMembershipCost({
    membershipPrices,
    selectedMembershipType,
  })

  return (
    <>
      <div className="invoice-summary">
        <div className="invoice-item">
          <img src="/assets/images/imagery/ST_Icon_membercard.svg" alt="" />
          <p className="title">{selectedMembershipType} Membership</p>
          <div className="cost">
            <p>{formatCurrency(membershipCost)}</p>
          </div>
        </div>
        {withDetail && (
          <>
            <div className="invoice-item total">
              <p className="title">Total:</p>
              <p className="cost">{formatCurrency(membershipCost)}</p>
            </div>
          </>
        )}
      </div>
    </>
  )
}

GiftInvoice.propTypes = exact(propTypes)

export default pure(GiftInvoice)
